module.exports = __webpack_public_path__ + "img/third-logo.8be63513.png";